import styles from './Outcomes.module.scss';
import OddsButton from '../../../../shared/OddsButton/OddsButton';
import {
    LANGUAGES,
    ODDS_BUTTON_TYPES,
    OUTCOME_STATUSES,
} from '../../../../../constants/defaultValues';
import { Tooltip } from '@material-ui/core';
import { formatSpecifierName, renderOdd } from '../../../../../utils/render';
import { useDispatch, useSelector } from 'react-redux';
import { addBetSlipBetLine, deleteBetSlipBetLine } from '../../../../../store/actions/betSlip';
import { sortOutcomeValues } from '../../../../../utils/helpers';
import { generateOutrightBetLine } from '../../../../../utils/betSlip';

const Outcomes = ({ market, season }) => {
    const dispatch = useDispatch();

    const locale = useSelector(state => state.settings.locale);
    const betLines = useSelector(state => state.betSlip.betLines);
    const producerStatuses = useSelector(state => state.feed.producerStatuses);
    const selectedOutcomes = [];

    const formattedMarket = {
        ...market,
        outcomeNames: Object.entries(market.outcomeNames || {}).map(([key, value]) => ({
            id: key,
            names: value,
        })),
    };

    const renderOddContent = ({ odd, marketStatus, outcomeStatus }) => {
        return renderOdd({ odd, marketStatus, outcomeStatus });
    };

    const checkSelectedOdd = (outcomeId, marketId) => {
        return betLines.some(bet => bet.marketId === marketId && bet.outcomeId === outcomeId);
    };

    const addToSlipHandler = (market, outcome) => {
        dispatch(addBetSlipBetLine(generateOutrightBetLine({ event: season, market, outcome })));
    };

    const onRemoveFromSlip = removedBet => {
        dispatch(deleteBetSlipBetLine(removedBet));
    };

    let outcomeIds = [];

    if (formattedMarket.outcomes) {
        if (selectedOutcomes.length) {
            outcomeIds = selectedOutcomes.filter(outcomeId =>
                market.outcomes.find(o => o.outcomeRefId === outcomeId),
            );
        } else {
            const sortedOutcomes = sortOutcomeValues(formattedMarket.outcomes, 'outcomeRefId');
            outcomeIds = sortedOutcomes.map(outcome => outcome.outcomeRefId);
        }
    }

    return outcomeIds.map(outcomeId => {
        const outcome = formattedMarket.outcomes?.find(
            outcome => outcome.outcomeRefId === outcomeId,
        );

        if (!outcome || !formattedMarket.outcomeNames) return null;

        const isSelected = checkSelectedOdd(outcome.outcomeRefId, market.id);

        const foundOutcomeName = formattedMarket.outcomeNames.find(
            o => o.id === outcome.outcomeRefId,
        );

        const outcomeName =
            foundOutcomeName?.names[locale] || foundOutcomeName?.names[LANGUAGES.eng];

        const isClosed =
            formattedMarket.closed ||
            formattedMarket.status !== 0 ||
            outcome.status !== 0 ||
            outcome.closed;
        const isFrozen = market.frozen || producerStatuses.isPreMatchDown;

        return outcomeName && outcome.status === OUTCOME_STATUSES.open ? (
            <div key={outcome.outcomeRefId} className={styles.outcome}>
                <OddsButton
                    marketStatus={market.status}
                    outcomeStatus={outcome.status}
                    type={ODDS_BUTTON_TYPES.long}
                    changeType={outcome.changeType}
                    odd={outcome.odd}
                    isFrozen={isFrozen}
                    isClosed={isClosed}
                    selected={isSelected}
                    addToSlip={() => addToSlipHandler(formattedMarket, outcome)}
                    removeFromSlip={() =>
                        onRemoveFromSlip({
                            eventId: season.currentSeasonId,
                            marketId: formattedMarket.id,
                            outcomeId: outcome.outcomeRefId,
                        })
                    }
                >
                    <div className={styles.outcomeContent}>
                        <Tooltip
                            title={
                                <span style={{ fontSize: '14px' }}>
                                    {formatSpecifierName({
                                        name: outcomeName,
                                        specifiers: market.specifiers,
                                    })}
                                </span>
                            }
                        >
                            <span
                                className={`${styles.outcomeName} ${
                                    isSelected ? styles.selected : ''
                                }`}
                            >
                                {formatSpecifierName({
                                    name: outcomeName,
                                    specifiers: market.specifiers,
                                })}
                            </span>
                        </Tooltip>
                        <span>
                            {renderOddContent({
                                odd: outcome.odd,
                                isClosed,
                                isFrozen,
                                marketStatus: market.status,
                                outcomeStatus: outcome.status,
                            })}
                        </span>
                    </div>
                </OddsButton>
            </div>
        ) : null;
    });
};

export default Outcomes;
